<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">{{$t('components.accounts.accountDeposit')}}</h4>
        <router-link
          class="btn btn-sm btn-primary"
          :to="'/accountsDeposits/create?account_id=' + $route.params.id"
          v-if="
            $parent.item.stat == 1 &&
            $site.invoices_allow &&
            ($user.admin ||
              $user.role.invoices_add)
          "
        >
          <i class="fas fa-plus"></i> {{$t('components.accounts.addition')}}
        </router-link>
      </div>
      <indexTable
        :searchText="$parent.$t('components.accounts.searchForAnOperation')"
        :withoutCard="true"
        :emptyTableText="$parent.$t('components.accounts.ThereAreCurrentlyNoDeposits')"
        :filter="{account_id: $route.params.id}"
        :emptyTableSubText="$parent.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
        :cloumns="[
          {
            column: 'code',
            title: $parent.$t('components.accounts.Process'),
            type: 'mainLink',
            sort: true,
          },
          {
            column: 'account_id',
            title: $t('components.accounts.accountName'),
            type: 'link',
            to: 'account',
            sort: true,
            link: true,
          },
          {
            column: 'safe_id',
            title: $t('components.accounts.Treasury'),
            type: 'link',
            to: 'safe',
            sort: true,
            link: true,
          },
          {
            column: 'date',
            title: $parent.$t('components.accounts.date'),
            type: 'text',
            sort: true,
          },
          {
            column: 'description',
            title: $parent.$t('components.accounts.AndThatIsAbout'),
            type: 'text',
            sort: true,
          },
          {
            column: 'cost',
            title: $parent.$t('components.accounts.cost'),
            type: 'text',
            sort: true,
          },
          {
            column: 'options',
            title: $parent.$t('components.accounts.actions'),
            type: 'options',
            options: [
              { name: 'show' },
              {
                name: 'edit',
                role:
                  $user.admin ||
                  $user.role.invoices_edit,
              },
              { name: 'outLink', role: true },
              { name: 'printInvoice', role: true },
              { name: 'download', role: true },
              {
                name: 'delete',
                role:
                  $user.admin ||
                  $user.role.invoices_delete,
              },
            ],
          },
        ]"
        :deleteText="{
          attention: $parent.$t('allerts.Attention'),
          areYouReallySureToDeleteTheItem:
            $parent.$t('allerts.areYouReallySureToDeleteTheItem'),
          close: $parent.$t('allerts.close'),
          confirm: $parent.$t('allerts.confirm'),
          loading: $parent.$t('allerts.loading'),
        }"
      />
    </div>
  </div>
</template>
<script>
import indexTable from "../../elements/index/indexTable.vue";
export default {
  data() {
    return {
      path: "/accountsDeposits",
    };
  },
  components: {
    indexTable,
  },
};
</script>
